import SweetScroll from 'sweet-scroll';
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
  sweetScroll();
  footerSlider();
});

// スムースクロールを実装するための関数
function sweetScroll() {
  const scroller = new SweetScroll({
    offset: 0,
    vertical: true,
    easing: 'easeOutQuint',
    horizontal: false,
    cancellable: true,
    updateURL: false,
    preventDefault: true,
    stopPropagation: true,
  });

  scroller.update({
    trigger: 'a[href^="#"]',
    duration: 1000,
  });
}

// フッターのスライドショー
function footerSlider() {
  const splide = new Splide('.footer__navigation__slider', {
    type: 'fade',
    autoplay: true,
    speed: 1500,
    pagination: false,
    arrows: false,
    rewind: true,
    interval: 6000,
    pauseOnHover: false,
    drag: false,
  });

  splide.mount();
}

// 追従CTAの処理
fixedCtaControl();
function fixedCtaControl() {
  const ctaButton = document.querySelector('.fixed-cta');

  window.addEventListener('scroll', () => {
    const screenHeight = window.innerHeight;
    const bodyHeight = document.body.scrollHeight;

    // 画面全体の 8% スクロールを行った場合に画面上に fixed-cta を表示する
    if (((bodyHeight - screenHeight) * 0.08) < scrollY) {
      ctaButton.classList.add('active');
    } else {
      ctaButton.classList.remove('active');
    }
  });
}

// サイトナビゲーションの管理
navigationToggle();
function navigationToggle() {
  const toggleButton = document.querySelector('.header__main__menu-button');
  const toggleNavigation = document.querySelector('.toggle-navigation');
  const noscroll = (e) => e.preventDefault();

  toggleButton.addEventListener('click', () => {
    if (!toggleButton.classList.contains('active')) {
      toggleButton.classList.add('active');
      toggleNavigation.classList.add('active');
      document.addEventListener('wheel', noscroll, { passive: false });
    } else {
      toggleButton.classList.remove('active');
      toggleNavigation.classList.remove('active');
      document.removeEventListener('wheel', noscroll);
    }
  });

  toggleNavigation.addEventListener('click', () => {
    toggleButton.classList.remove('active');
    toggleNavigation.classList.remove('active');
  });
}
